export default __webpack_public_path__ + "static/media/waning-red.93b2c215.svg";